import request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取协议(registration: 注册须知，agency: 经销商合同)
   */
  static getAgreement(type) {
    return request({
      url: `basic/contract/query/${type}`,
      host: config.HOST_MALL
    });
  }

  static getStoreAgreements(params) {
    return request({
      url: `store_policy/contract`,
      host: config.HOST_STORE,
      params
    });
  }

  // 根据id查合同
  static queryContractById(params) {
    return request({
      url: `basic/contract/query/queryById`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }

  // 上报内容提醒次数
  static reportAgreement(params) {
    return request({
      url: `basic/reminder/agreement/report`,
      host: config.HOST_MALL,
      method: 'post',
      params
    });
  }

  // 上报合同确认
  static reportAgreementConfirm(params) {
    return request({
      url: `basic/reminder/agreement/report/confirm?contractCode=${params.contractCode}`,
      host: config.HOST_MALL,
      method: 'post',
      params: {}
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Agreements/AgreementsServ.js